import React from "react";
import MaratiLogo from "assets/images/marati_logo.png";
import { useAppScope } from "master";

export const MwcdLogoComopent = ({ customClass = "marathi-footer-logo" }) => {
    const { isMWCD } = useAppScope();

    return (
        isMWCD && (
            <div className={customClass}>
                <img src={MaratiLogo} alt="Marathi Logo" />
            </div>
        )
    );
};